import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';

// Ported 1:1 from the prototype `.field` (label + control + hint stack).
export const styles = {
  field: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "xlr87oj",
    $$css: true
  },
  labelRow: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kAzted: "x1hshjfz",
    $$css: true
  },
  label: {
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    k63SB2: "xomqrzn",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  meta: {
    kGuDYH: "x34ze3o",
    $$css: true
  },
  hint: {
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  error: {
    kMwMTN: "x2wi9gy",
    $$css: true
  },
  required: {
    kMwMTN: "x2wi9gy",
    k63SB2: "xomqrzn",
    $$css: true
  }
};